import React from 'react';
import { Button } from '@lwt-helix/buttons';
import { lwaTableButtonStyles } from './UserDirectory.css';
import { ButtonText, Status } from '../../../constants/Invitations';
import { format } from 'date-fns';

export function filterOptions(option) {
    const optionInactiveDate = option?.inactiveDate ? new Date(option.inactiveDate) : null;
    if ((optionInactiveDate && optionInactiveDate.getTime() <= new Date().getTime()) || option?.lwaId)
        return null;

    if (option?.primaryEmailAddress?.includes(';'))
        option.primaryEmailAddress = option.primaryEmailAddress.split(';')[0];

    return option;
}

export function mapOptions(option) {
    return {
        ...option,
        value: option?.primaryEmailAddress,
        label: `${option?.firstName} ${option?.lastName}`,
    }
}

const getStatusBtn = (user, index, clickHandler, isManageUsers, isInactive) => {
    let showButton = true;
    let spanStyle = {};
    let spanClass = '';
    let icon = '';
    let disabled = false;

    switch (user?.status?.toUpperCase()) {
        case Status.PENDINGAPPROVAL:
            spanClass = 'text-success font-weight-bold';
            icon = 'done';
            disabled = !isManageUsers;
            break;
        case Status.INVITED:
            spanStyle = { transform: 'rotate(-30deg)', marginTop: '-.5em', fontSize: '140%' };
            spanClass = 'text-info';
            icon = 'send';
            break;
        default:
            showButton = false;
            break;
    }

    return showButton ?
        <Button
            style={lwaTableButtonStyles}
            className="btn btn-secondary btn-xs"
            dataLwtId={`status-button-${index}`}
            onClick={() => clickHandler(user?.id)}
            disabled={disabled}
        >
            <span className={`material-icons ${spanClass} mr-1`} style={spanStyle}>{icon}</span>
            {ButtonText[user?.status?.toUpperCase()]}
        </Button>
        : ButtonText[user?.status ? user?.status.toUpperCase() : (isInactive ? Status.INACTIVE : Status.APPROVED)];
};

export function mapTableData(
    invitations,
    securityGroups,
    reinviteUserHandler,
    approveInvitationHandler,
    isManageUsers,
    clientId
) {
    return invitations.map((user, index) => {
        const clickHandler = user?.status?.toUpperCase() === Status.PENDINGAPPROVAL
            ? approveInvitationHandler
            : user?.status?.toUpperCase() === Status.INVITED
                ? reinviteUserHandler
                : null;

        const securityGroup = user?.status
            ? securityGroups.find(group => group.id === user?.roleId)
            : securityGroups.find(group => group.users?.some(u => u.userId === user?.id));

        const userStatus = user?.status ? user?.status.toUpperCase() : Status.APPROVED;
        const getStatusDate = () => {
            let tempDate = userStatus === Status.INVITED ? user?.date : user?.statusChangeDate;
            if (tempDate) {
                tempDate = new Date(tempDate);
                tempDate.setDate(tempDate.getUTCDate());
                tempDate = tempDate.toLocaleDateString('en-US');
            }
            return tempDate;
        };
        const isInactive = user?.clients?.find(
            client => client.clientId === clientId)?.inactiveDate <= format(Date.now(), 'yyyy-MM-dd') ?? false;
        return {
            ...user,
            key: index,
            userName: `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim(),
            dataLwtId: `lwa-table-record-${user?.id}`,
            status: user?.status ? user.status.toUpperCase() : (isInactive ? Status.INACTIVE : Status.APPROVED),
            statusBtn: getStatusBtn(user, index, clickHandler, isManageUsers, isInactive),
            date: user?.date,
            statusChangeDate: user?.statusChangeDate,
            statusDate: getStatusDate(),
            securityGroup: securityGroup,
            securityGroupId: securityGroup?.id,
            selected: false
        };
    });
}
